<template>
    <div class="modal fade" tabindex="-1" id="DadosInstituicao" ref="modalDadosInstituicao">
        <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content dados-instituicao-modal">
                <div class="modal-body dados-instituicao-body">
                    <header class="dados-instituicao-header">
                        <div class="dados-instituicao-header__text">
                            <span class="dados-instituicao-header__eyebrow">Instituição</span>
                            <h3 class="dados-instituicao-header__title">Atualize os dados da sua instituição</h3>
                            <p class="dados-instituicao-header__description">Personalize as informações institucionais para que seus clientes reconheçam sua marca imediatamente.</p>
                        </div>
                    </header>

                    <div class="dados-instituicao-content">
                        <div class="dados-instituicao-logos-panel">
                            <div class="dados-instituicao-logos-panel__head">
                                <span class="dados-instituicao-logos-panel__eyebrow">Identidade</span>
                                <p class="dados-instituicao-logos-panel__lead">Logos para o portal e para o SollAI</p>
                            </div>
                            <div class="dados-instituicao-media-stack">
                                <aside class="dados-instituicao-media" :class="{ 'dados-instituicao-media--has-image': instituicao.urlImagemS3 || cropImg }">
                                    <div class="dados-instituicao-media__wrapper">
                                        <template v-if="instituicao.urlImagemS3">
                                            <div class="dados-instituicao-preview">
                                                <img :src="instituicao.urlImagemS3" alt="Logo da instituição" />
                                            </div>
                                        </template>
                                        <template v-else>
                                            <template v-if="cropImg">
                                                <div class="dados-instituicao-preview">
                                                    <img :src="cropImg" alt="Pré-visualização da logo" />
                                                </div>
                                            </template>
                                            <template v-else>
                                                <label class="dados-instituicao-dropzone" for="urlImg">
                                                    <div class="dados-instituicao-dropzone__icon">
                                                        <i class="fas fa-cloud-upload-alt"></i>
                                                    </div>
                                                    <div class="dados-instituicao-dropzone__text">
                                                        <strong>Clique para enviar o logo</strong>
                                                        <small>PNG ou JPG, até 5MB</small>
                                                    </div>
                                                </label>
                                            </template>

                                            <div v-if="preview" class="dados-instituicao-cropper">
                                                <label class="dados-instituicao-cropper__reupload" for="urlImg">Escolher outra imagem</label>
                                                <section class="dados-instituicao-cropper__canvas">
                                                    <vue-cropper ref="cropper"
                                                                 :aspect-ratio="1"
                                                                 :src="imgSrc"
                                                                 :autoCropArea="1"
                                                                 :resposive="true"
                                                                 :background="false"
                                                                 preview=".dados-instituicao-cropper__preview--inst"
                                                                 style="max-width:100%; max-height: 30vh;" />
                                                </section>
                                                <section class="dados-instituicao-cropper__preview-wrapper">
                                                    <div class="dados-instituicao-cropper__preview dados-instituicao-cropper__preview--inst" />
                                                </section>
                                                <section class="dados-instituicao-cropper__actions">
                                                    <button type="button" class="dados-instituicao-cropper__apply" @click.prevent="cropImage">Aplicar recorte</button>
                                                </section>
                                            </div>
                                        </template>

                                        <input type="file"
                                               id="urlImg"
                                               class="dados-instituicao-input-file"
                                               accept="image/png, image/jpeg, image/gif"
                                               @change="setImage" />
                                    </div>

                                    <div class="dados-instituicao-media__meta">
                                        <strong class="dados-instituicao-media__title">Logo da instituição</strong>
                                        <small class="dados-instituicao-media__hint">Utilize uma imagem quadrada para melhor resultado.</small>
                                        <button v-if="instituicao.urlImagemS3 || cropImg"
                                                type="button"
                                                class="dados-instituicao-media__remove"
                                                @click="removerImagem">
                                            Remover logo
                                        </button>
                                    </div>
                                </aside>

                                <aside class="dados-instituicao-media dados-instituicao-media--sistema" :class="{ 'dados-instituicao-media--has-image': instituicao.urlImagemSistemaS3 || cropImgSistema }">
                                    <div class="dados-instituicao-media__wrapper">
                                        <template v-if="instituicao.urlImagemSistemaS3">
                                            <div class="dados-instituicao-preview">
                                                <img :src="instituicao.urlImagemSistemaS3" alt="Logo do sistema" />
                                            </div>
                                        </template>
                                        <template v-else>
                                            <template v-if="cropImgSistema">
                                                <div class="dados-instituicao-preview">
                                                    <img :src="cropImgSistema" alt="Pré-visualização do logo do sistema" />
                                                </div>
                                            </template>
                                            <template v-else>
                                                <label class="dados-instituicao-dropzone" for="urlImgSistema">
                                                    <div class="dados-instituicao-dropzone__icon">
                                                        <i class="fas fa-cloud-upload-alt"></i>
                                                    </div>
                                                    <div class="dados-instituicao-dropzone__text">
                                                        <strong>Logo do sistema (SollAI)</strong>
                                                        <small>PNG ou JPG, até 5MB</small>
                                                    </div>
                                                </label>
                                            </template>

                                            <div v-if="previewSistema" class="dados-instituicao-cropper">
                                                <label class="dados-instituicao-cropper__reupload" for="urlImgSistema">Escolher outra imagem</label>
                                                <section class="dados-instituicao-cropper__canvas">
                                                    <vue-cropper ref="cropperSistema"
                                                                 :aspect-ratio="3"
                                                                 :src="imgSrcSistema"
                                                                 :autoCropArea="1"
                                                                 :resposive="true"
                                                                 :background="false"
                                                                 preview=".dados-instituicao-cropper__preview--sis"
                                                                 style="max-width:100%; max-height: 30vh;" />
                                                </section>
                                                <section class="dados-instituicao-cropper__preview-wrapper">
                                                    <div class="dados-instituicao-cropper__preview dados-instituicao-cropper__preview--sis" />
                                                </section>
                                                <section class="dados-instituicao-cropper__actions">
                                                    <button type="button" class="dados-instituicao-cropper__apply" @click.prevent="cropImageSistema">Aplicar recorte</button>
                                                </section>
                                            </div>
                                        </template>

                                        <input type="file"
                                               id="urlImgSistema"
                                               class="dados-instituicao-input-file"
                                               accept="image/png, image/jpeg, image/gif"
                                               @change="setImageSistema" />
                                    </div>

                                    <div class="dados-instituicao-media__meta">
                                        <strong class="dados-instituicao-media__title">Identidade no sistema</strong>
                                        <small class="dados-instituicao-media__hint">Exibida no contexto do SollAI; </small>
                                        <button v-if="instituicao.urlImagemSistemaS3 || cropImgSistema"
                                                type="button"
                                                class="dados-instituicao-media__remove"
                                                @click="removerImagemSistema">
                                            Remover logo do sistema
                                        </button>
                                    </div>
                                </aside>
                            </div>
                        </div>

                        <form class="dados-instituicao-form" id="formDadosInstituicao">
                            <div class="dados-instituicao-form__group">
                                <label class="dados-instituicao-form__label" for="instituicao_nmExibicao">Nome</label>
                                <input class="dados-instituicao-input"
                                       :class="{ 'dados-instituicao-input--error': camposInvalidos.nmExibicao }"
                                       type="text"
                                       id="instituicao_nmExibicao"
                                       name="instituicao.nmExibicao"
                                       v-model="instituicao.nmExibicao"
                                       maxlength="100"
                                       required>
                            </div>

                            <div class="dados-instituicao-form__group">
                                <label class="dados-instituicao-form__label" for="instituicao_nrCpfCnpj">CNPJ</label>
                                <vue-mask class="dados-instituicao-input"
                                          id="instituicao_nrCpfCnpj"
                                          name="instituicao.nrCpfCnpj"
                                          v-model="instituicao.nrCpfCnpj"
                                          mask="AA.AAA.AAA/AAAA-00"
                                          :raw="false"
                                          :options="options"
                                          disabled>
                                </vue-mask>
                            </div>


                        </form>
                    </div>
                    <button class="dados-instituicao-submit" type="button" @click="enviar">
                        <span>Salvar atualizações</span>
                    </button>
                </div><!-- .modal-body -->
                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3" data-bs-dismiss="modal">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg><!-- x-lg -->
                </button><!-- modal-close -->
            </div><!-- .modal-content -->
        </div><!-- .modal-dialog -->
    </div><!-- .modal -->
</template>

<script>
    import vueMask from 'vue-jquery-mask'
    import { urlApi, avisoSucesso, avisoErro } from '@/config/global'
    import axios from 'axios'
    import VueCropper from 'vue-cropperjs';
    import 'cropperjs/dist/cropper.css';

    export default {
        name: 'DadosInstituicao',
        components: {
            VueCropper,
            vueMask
        },
        data: function () {
            return {

                limiteCaracteres: 500,

                instituicao: {
                    nrCpfCnpj: null,
                    nmExibicao: null,
                    urlImagem: null,
                    urlImagemS3: null,
                    urlImagemSistema: null,
                    urlImagemSistemaS3: null,
                },
                camposInvalidos: {
                    nmExibicao: false
                },
                optionsCroper: {
                    skin: 'sollicita',
                    dropareaMessage: 'Clique aqui para selecionar a imagem',
                    selectButtonLabel: 'Selecione',
                    cropArea: 'box',
                    aspectRatio: 1.7,
                    croppedHeight: 200,
                    croppedWidth: 500,
                    maxCropperHeight: 500,
                    saveButtonLabel: 'Aplicar',
                    resultQuality: 1,
                    previewQuality: 1,
                    imgDefault: null,
                },

                options: {
                    placeholder: '',
                },

                preview: null,
                imgSrc: '',
                cropImg: null,
                imageFile: null,

                previewSistema: null,
                imgSrcSistema: '',
                cropImgSistema: null,
                imageFileSistema: null,

                modal: null,
            }
        },
        props: {
            showModal: Boolean,
        },
        computed: {

            user() {
                return this.$store.state.user
            },
        },
        methods: {
            enviar() {
                if (!this.validarCamposObrigatorios()) return;

                if (this.checkForm()) {
                    let $this = this;
                    const formData = new FormData();

                    if ($this.imageFile != null && $this.preview) {
                        formData.append("form.file", $this.imageFile, $this.preview.nome);
                    }

                    if ($this.imageFileSistema != null && $this.previewSistema) {
                        formData.append("form.fileSistema", $this.imageFileSistema, $this.previewSistema.nome);
                    }

                    formData.append("form.nmExibicao", $this.instituicao.nmExibicao);
                    if ($this.instituicao.urlImagem) {
                        formData.append("form.urlImagem", $this.instituicao.urlImagem);
                    }
                    if ($this.instituicao.urlImagemSistema) {
                        formData.append("form.urlImagemSistema", $this.instituicao.urlImagemSistema);
                    }


                    axios.post(`${urlApi}/Instituicao/Post`, formData, { headers: { "Content-Type": `multipart/form-data; boundary=${formData._boundary}`, } })
                        .then(res => {
                            if (res.data.success) {
                                // aviso ok
                                avisoSucesso("Dados alterados com sucesso!");
                                $this.$store.commit('setInstituicao');
                                //$this.getDadosInstituicao();
                                $this.close();
                            } else {
                                avisoErro("Não foi possível alterar seus dados.");
                            }
                        })
                        .catch(res => {
                            if (res.response.data != undefined) {
                                avisoErro(res.response.data);
                            } else {
                                avisoErro(res.response.statusText);
                            }
                        });
                }
                return false;
            },

            validarCamposObrigatorios() {
                this.camposInvalidos.nmExibicao = !this.instituicao.nmExibicao?.trim();

                if (this.camposInvalidos.nmExibicao) {
                    avisoErro("Preencha todos os campos obrigatórios.");
                    return false;
                }

                if (this.instituicao.nmExibicao.length > 250) {
                    avisoErro("O limite de caracteres do \"Nome\" foi ultrapassado");
                    return false;
                }

                return true;
            },

            getDadosInstituicao() {
                let $this = this;
                axios.get(`${urlApi}/Instituicao/Get`)
                    .then(res => {
                        if (res.data.success) {
                            var instituicao = res.data.data;
                            $this.instituicao = {
                                nrCpfCnpj: instituicao.nrCpfCnpj,
                                nmExibicao: instituicao.nmExibicao,
                                urlImagem: instituicao.urlImagem,
                                urlImagemS3: instituicao.urlImagemS3,
                                urlImagemSistema: instituicao.urlImagemSistema,
                                urlImagemSistemaS3: instituicao.urlImagemSistemaS3,
                            };

                        } else {
                            avisoErro("Não foi possível carregar os dados.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro("Não foi possível carregar os dados.");
                        }
                    });
            },

            checkForm() {
                var form = document.getElementById('formDadosInstituicao')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                if (this.limiteCaracteres > 0) {
                    if (this.instituicao.nmExibicao.length > 250) {
                        avisoErro("O limite de caracteres do \"Nome\" foi ultrapassado")
                        return false;
                    }
                }

                return true;
            },

            removerImagem() {
                let $this = this;
                $this.preview = null;
                $this.cropImg = null;
                $this.imageFile = null;
                $this.instituicao.urlImagem = null;
                $this.instituicao.urlImagemS3 = null;
                const input = document.getElementById('urlImg');
                if (input) input.value = '';
            },

            removerImagemSistema() {
                let $this = this;
                $this.previewSistema = null;
                $this.cropImgSistema = null;
                $this.imageFileSistema = null;
                $this.instituicao.urlImagemSistema = null;
                $this.instituicao.urlImagemSistemaS3 = null;
                const input = document.getElementById('urlImgSistema');
                if (input) input.value = '';
            },

            load() {
                this.getDadosInstituicao();
                this.$store.commit('setInstituicao');
            },


            setImage(e) {
                const file = e.target.files[0];
                if (!file) return;
                this.file = file;
                this.preview = {};
                this.preview.nome = file.name;
                this.preview.type = file.type;

                if (file.type.indexOf('image/') === -1) {
                    alert('Please select an image file');
                    return;
                }

                if (typeof FileReader === 'function') {
                    const reader = new FileReader();

                    reader.onload = (event) => {
                        this.imgSrc = event.target.result;
                        if (this.$refs.cropper) {
                            this.$refs.cropper.replace(event.target.result);
                        }
                    };
                    reader.onloadend = () => {
                        this.preview.img = reader.result;
                        this.$forceUpdate();
                    };
                    reader.readAsDataURL(file);
                } else {
                    alert('Sorry, FileReader API not supported');
                }
            },

            setImageSistema(e) {
                const file = e.target.files[0];
                if (!file) return;
                this.previewSistema = {};
                this.previewSistema.nome = file.name;
                this.previewSistema.type = file.type;

                if (file.type.indexOf('image/') === -1) {
                    alert('Selecione um arquivo de imagem');
                    return;
                }

                if (typeof FileReader === 'function') {
                    const reader = new FileReader();

                    reader.onload = (event) => {
                        this.imgSrcSistema = event.target.result;
                        if (this.$refs.cropperSistema) {
                            this.$refs.cropperSistema.replace(event.target.result);
                        }
                    };
                    reader.onloadend = () => {
                        this.previewSistema.img = reader.result;
                        this.$forceUpdate();
                    };
                    reader.readAsDataURL(file);
                } else {
                    alert('Sorry, FileReader API not supported');
                }
            },

            cropImage() {
                let $this = this;
                // Aplica as mudanças de edição na imagem de perfil
                if (this.$refs.cropper) {
                    const canvas = this.$refs.cropper.getCroppedCanvas();
                    this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();


                    // Converte para um blob e salva a nova imagem cropada
                    canvas.toBlob((blob) => {
                        if (blob) {
                            //$this.imageFile = blob;
                            blob.name = $this.preview.nome;
                            $this.imageFile = new File([blob], $this.preview.nome, { type: $this.preview.type });
                        }

                        // Mantém o nome e a extensão original do arqvuivo
                        //const fileExtension = this.originalFileName.split('.').pop().toLowerCase();
                        //const mimeType = `image/${fileExtension === 'jpg' ? 'jpeg' : fileExtension}`;


                        // Cria um novo arquivo com o nome e a extensão do arquivo original 
                        //this.imageFile = new File([blob], this.originalFileName, { type: mimeType });
                        


                        // Define o avatar da imagem a partir da imagem cropada
                        //this.avatar = URL.createObjectURL(this.imageFile);


                    }, "image/png");
                }
            },

            cropImageSistema() {
                let $this = this;
                if (this.$refs.cropperSistema) {
                    const canvas = this.$refs.cropperSistema.getCroppedCanvas();
                    this.cropImgSistema = this.$refs.cropperSistema.getCroppedCanvas().toDataURL();

                    canvas.toBlob((blob) => {
                        if (blob) {
                            $this.imageFileSistema = new File([blob], $this.previewSistema.nome, { type: $this.previewSistema.type });
                        }
                    }, "image/png");
                }
            },


            close() {
                if (this.modal == null) {
                    this.modal = new window.bootstrap.Modal(this.$refs.modalDadosInstituicao);
                }
                this.modal.hide();
            },

        },
        mounted: function () {
            this.load();

            const esperaBoootstrap = () => {
                if (window.bootstrap && window.bootstrap.Modal) {
                    this.modal = new window.bootstrap.Modal(this.$refs.modalDadosInstituicao);
                } else {
                    setTimeout(esperaBoootstrap, 50)
                }
            }
            this.$nextTick(() => esperaBoootstrap());
        },
        watch: {
            showModal: function () {
                if (this.modal == null) {
                    this.modal = new window.bootstrap.Modal(this.$refs.modalDadosInstituicao);
                }
                this.modal.show();

                this.load();
            },

        }

    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" scoped>
    .modal-xl {
        width: min(80vw, calc(100vw - 32px));
        max-width: min(80vw, calc(100vw - 32px));
        margin: 0 auto;
    }

    .dados-instituicao-modal {
        border: none;
        border-radius: 28px;
        background: linear-gradient(140deg, #f7faff 0%, #eef2ff 42%, #ffffff 100%);
        box-shadow: 0 30px 80px -20px rgba(21, 38, 78, 0.25);
        position: relative;
        /*overflow: hidden;*/
    }

    .dados-instituicao-body {
        padding: 40px clamp(24px, 4.5vw, 56px);
        display: flex;
        flex-direction: column;
        gap: 32px;
    }

    .dados-instituicao-header {
        display: flex;
        justify-content: space-between;
        gap: 24px;
        align-items: flex-start;
        position: relative;
    }

    .dados-instituicao-header__text {
        display: flex;
        flex-direction: column;
        gap: 8px;
        color: #1d2533;
    }

    .dados-instituicao-header__eyebrow {
        font-size: 0.75rem;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        font-weight: 600;
        color: #4c5b8f;
    }

    .dados-instituicao-header__title {
        font-size: clamp(1.5rem, 2.4vw, 2rem);
        font-weight: 700;
        margin: 0;
    }

    .dados-instituicao-header__description {
        margin: 0;
        font-size: 0.95rem;
        line-height: 1.6;
        color: rgba(29, 37, 51, 0.72);
    }

    .dados-instituicao-content {
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        gap: clamp(24px, 3.5vw, 48px);
        align-items: stretch;
    }

    .dados-instituicao-logos-panel {
        display: flex;
        flex-direction: column;
        gap: clamp(14px, 2vw, 20px);
        min-width: 0;
        width: 100%;
        max-width: none;
    }

    .dados-instituicao-logos-panel__head {
        padding: 0 2px;
    }

    .dados-instituicao-logos-panel__eyebrow {
        display: block;
        font-size: 0.72rem;
        letter-spacing: 0.14em;
        text-transform: uppercase;
        font-weight: 700;
        color: #4c5b8f;
        margin-bottom: 4px;
    }

    .dados-instituicao-logos-panel__lead {
        margin: 0;
        font-size: 0.9rem;
        line-height: 1.45;
        color: rgba(29, 37, 51, 0.62);
    }

    .dados-instituicao-media-stack {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: clamp(14px, 2vw, 22px);
        align-items: stretch;
    }

    .dados-instituicao-media {
        display: flex;
        flex-direction: column;
        gap: clamp(14px, 2vw, 20px);
        padding: clamp(14px, 2.2vw, 22px);
        border-radius: 18px;
        background: rgba(255, 255, 255, 0.82);
        box-shadow: 0 14px 36px -22px rgba(45, 57, 110, 0.4);
        border: 1px solid rgba(105, 128, 178, 0.14);
        transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
        min-width: 0;
    }

    .dados-instituicao-media--sistema {
        background: linear-gradient(165deg, rgba(255, 255, 255, 0.92) 0%, rgba(241, 246, 255, 0.88) 100%);
        border-color: rgba(79, 123, 255, 0.2);
    }

    .dados-instituicao-media--sistema.dados-instituicao-media--has-image {
        border-color: rgba(79, 123, 255, 0.28);
    }

    .dados-instituicao-media--has-image {
        transform: translateY(-2px);
        box-shadow: 0 20px 44px -24px rgba(45, 57, 110, 0.42);
    }

    .dados-instituicao-media__wrapper {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .dados-instituicao-preview {
        width: 100%;
        aspect-ratio: 1 / 1;
        border-radius: 16px;
        overflow: hidden;
        background: radial-gradient(circle at top, rgba(96, 119, 180, 0.25), rgba(96, 119, 180, 0));
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid rgba(76, 91, 143, 0.15);
    }

    .dados-instituicao-preview img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
    }

    .dados-instituicao-dropzone {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 12px;
        width: 100%;
        aspect-ratio: 1 / 1;
        border-radius: 16px;
        border: 2px dashed rgba(76, 91, 143, 0.35);
        background: linear-gradient(180deg, rgba(237, 242, 255, 0.8) 0%, rgba(255, 255, 255, 0.6) 100%);
        color: #3b4674;
        text-align: center;
        padding: 24px;
        transition: all 0.3s ease;
    }

    .dados-instituicao-dropzone:hover {
        border-color: rgba(76, 91, 143, 0.65);
        background: linear-gradient(180deg, rgba(237, 242, 255, 1) 0%, rgba(255, 255, 255, 0.85) 100%);
        box-shadow: 0 20px 45px -30px rgba(55, 75, 130, 0.45);
    }

    .dados-instituicao-dropzone__icon {
        width: 56px;
        height: 56px;
        border-radius: 18px;
        display: grid;
        place-items: center;
        background: rgba(76, 91, 143, 0.12);
        color: #3b4674;
        font-size: 1.75rem;
    }

    .dados-instituicao-dropzone__text strong {
        display: block;
        font-weight: 600;
        font-size: clamp(0.82rem, 1.6vw, 0.95rem);
        line-height: 1.25;
    }

    .dados-instituicao-dropzone__text small {
        display: block;
        font-size: 0.85rem;
        color: rgba(59, 70, 116, 0.7);
    }

    .dados-instituicao-input-file {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        border: 0;
    }

    .dados-instituicao-media__meta {
        display: flex;
        flex-direction: column;
        gap: 8px;
        color: rgba(29, 37, 51, 0.8);
    }

    .dados-instituicao-media__title {
        font-size: clamp(0.88rem, 1.8vw, 0.98rem);
        font-weight: 600;
    }

    .dados-instituicao-media__hint {
        font-size: 0.85rem;
        color: rgba(59, 64, 85, 0.7);
    }

    .dados-instituicao-media__remove {
        align-self: flex-start;
        background: transparent;
        border: none;
        color: #d94f70;
        font-weight: 600;
        padding: 0;
        cursor: pointer;
        transition: color 0.2s ease;
    }

    .dados-instituicao-media__remove:hover {
        color: #b13d58;
    }

    .dados-instituicao-form {
        background: rgba(255, 255, 255, 0.9);
        border-radius: 20px;
        padding: clamp(20px, 3vw, 32px);
        box-shadow: 0 18px 40px -28px rgba(53, 61, 104, 0.35);
        border: 1px solid rgba(105, 128, 178, 0.12);
        display: flex;
        flex-direction: column;
        gap: 24px;
        min-width: 0;
        height: 100%;
        justify-content: center;
    }

    .dados-instituicao-grid {
        display: grid;
        gap: 20px;
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    }

    .dados-instituicao-form__group {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .dados-instituicao-form__label {
        font-size: 0.95rem;
        font-weight: 600;
        color: rgba(29, 37, 51, 0.85);
    }

    .dados-instituicao-input {
        width: 100%;
        border-radius: 12px;
        border: 1px solid rgba(76, 91, 143, 0.18);
        padding: 12px 16px;
        font-size: 1rem;
        /*background: rgba(255, 255, 255, 0.95);*/
        color: #1d2533;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    .dados-instituicao-input:focus {
        outline: none;
        border-color: rgba(76, 91, 143, 0.6);
        box-shadow: 0 0 0 4px rgba(96, 119, 180, 0.18);
    }

    .dados-instituicao-input--error {
        border-color: #e8b6c1 !important;
        box-shadow: 0 0 0 4px rgba(196, 104, 110, 0.18);
    }

    .dados-instituicao-submit {
        border: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        border-radius: 14px;
        padding: 16px 22px;
        font-weight: 600;
        font-size: 1rem;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        background: linear-gradient(135deg, #4f7bff 0%, #2745d8 100%);
        color: #ffffff;
        box-shadow: 0 15px 30px -12px rgba(39, 69, 216, 0.55);
        transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
        cursor: pointer;
    }

        .dados-instituicao-submit:hover:not(:disabled) {
            transform: translateY(-2px);
            box-shadow: 0 18px 36px -14px rgba(39, 69, 216, 0.6);
            filter: brightness(1.05);
        }

        .dados-instituicao-submit:disabled {
            cursor: not-allowed;
            background: linear-gradient(135deg, #b8c4ff 0%, #9baaff 100%);
            box-shadow: none;
            opacity: 0.75;
        }

    .dados-instituicao-cropper {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
        border-radius: 16px;
        background: rgba(247, 249, 255, 0.95);
        border: 1px solid rgba(76, 91, 143, 0.2);
    }

    .dados-instituicao-cropper__reupload {
        align-self: flex-end;
        font-size: 0.85rem;
        font-weight: 600;
        color: #4c5b8f;
        cursor: pointer;
        text-decoration: underline;
        transition: color 0.2s ease;
    }

    .dados-instituicao-cropper__reupload:hover {
        color: #32407a;
    }

    .dados-instituicao-cropper__canvas {
        width: 100%;
        border-radius: 12px;
        overflow: hidden;
    }

    .dados-instituicao-cropper__preview-wrapper {
        display: flex;
        justify-content: center;
    }

    .dados-instituicao-cropper__preview {
        width: 120px;
        height: 120px;
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 10px 30px -18px rgba(53, 64, 110, 0.55);
    }

    .dados-instituicao-cropper__actions {
        display: flex;
        justify-content: center;
    }

    .dados-instituicao-cropper__apply {
        border: none;
        border-radius: 999px;
        padding: 10px 20px;
        font-weight: 600;
        background: linear-gradient(120deg, #4c5b8f 0%, #6476d6 100%);
        color: #fff;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .dados-instituicao-cropper__apply:hover {
        transform: translateY(-1px);
        box-shadow: 0 12px 30px -16px rgba(76, 91, 143, 0.45);
    }

    @media (max-width: 992px) {
        .modal-xl {
            width: min(80vw, calc(100vw - 24px));
            max-width: min(80vw, calc(100vw - 24px));
        }

        .dados-instituicao-content {
            grid-template-columns: 1fr;
        }

        .dados-instituicao-form {
            height: auto;
            justify-content: flex-start;
        }

        .dados-instituicao-media {
            padding: clamp(16px, 3vw, 22px);
        }
    }

    @media (max-width: 640px) {
        .dados-instituicao-media-stack {
            grid-template-columns: 1fr;
        }
    }

    @media (max-width: 576px) {
        .dados-instituicao-body {
            padding: 28px 20px;
        }

        .dados-instituicao-submit {
            width: 100%;
        }
    }
</style>

